<nb-card style="width: 60vw; height: 65vh">
  <nb-card-header>
    <h6 class="float-left">Search</h6>
    <nb-icon
      icon="close-outline"
      class="float-right cursor-pointer mt-1"
      nbTooltip="Close Search"
      (click)="ref?.close()"
    ></nb-icon>
  </nb-card-header>
  <nb-card-body class="pt-0 mt-2">
    <div class="search-bar">
      <form class="search d-flex rounded">
        <input
          class="search-input rounded"
          style="border: none !important"
          nbInput
          autofocus
          autocomplete="off"
          type="text"
          id="searchInput"
          placeholder="Search projects, environments, resources and pages"
          [formControl]="searchTerm"
          (ngModelChange)="processSearch()"
          (keydown.enter)="onSearch($event)"
          #searchInputToFocus
        />
        <label
          *ngIf="searchTerm?.value?.length === 0"
          style="background-color: #fff"
          for="searchInput"
          class="rounded pr-3 border-0 d-flex align-items-center mb-0 cursor-pointer"
        >
          <nb-icon
            class="text-basic-color"
            icon="search-outline"
            pack="eva"
          ></nb-icon>
        </label>
        <label
          *ngIf="searchTerm?.value?.length > 0"
          style="background-color: #fff"
          class="rounded pr-3 border-0 d-flex align-items-center mb-0 cursor-pointer"
          (click)="clearSearch()"
          nbTooltip="Clear Search"
        >
          <nb-icon
            class="text-basic-color"
            icon="close-outline"
            pack="eva"
          ></nb-icon>
        </label>
      </form>
    </div>
    <div
      *ngIf="searchState !== 'dataFound'"
      [ngClass]="{
        'search-parent': searchState !== 'recentSearchPresent'
      }"
    >
      <img
        *ngIf="searchState !== 'recentSearchPresent'"
        style="width: 6rem"
        class="mb-3"
        [src]="searchStates[searchState][0]"
      />
      <span *ngIf="searchState !== 'recentSearchPresent'">{{
        searchStates[searchState][1]
      }}</span>
      <div *ngIf="searchState === 'recentSearchPresent'">
        <label class="paragraph-3 mt-3">Recent Searches</label>
        <div
          class="py-1 cursor-pointer context-parent"
          *ngFor="let search of recentSearch"
          (click)="this.searchTerm?.setValue(search)"
        >
          <span>{{ search }}</span>
        </div>
      </div>
    </div>
    <nb-tabset
      class="mt-3"
      fullWidth
      *ngIf="
        (filteredResults['STACK']?.length ||
          filteredResults['CLUSTER']?.length ||
          filteredResults['RESOURCE']?.length ||
          filteredResults['ROUTE']?.length) &&
        searchState === 'dataFound'
      "
    >
      <nb-tab
        class="mt-2 p-0"
        tabTitle="{{ tabValues[key]?.title }}"
        *ngFor="let key of tabOrder"
        badgeText="{{ filteredResults[key]?.length || 0 }}"
        badgeStatus="primary"
        [disabled]="false"
        #searchTab
      >
        <div *ngIf="filteredResults[key]?.length > 0">
          <div
            (click)="navigateTo($event, typeResult, typeResult?.data?.urlType)"
            *ngFor="let typeResult of filteredResults[key]"
            class="d-flex mt-3 context-parent"
          >
            <div class="d-flex context-parent" *ngIf="key === 'ROUTE'">
              <div
                class="d-flex align-items-center searchItem"
                *ngFor="
                  let term of typeResult?.data?.urlComponents;
                  let i = index
                "
              >
                <div
                  *ngIf="i !== 0"
                  class="separator mx-2 d-flex align-items-center justify-content-center"
                >
                  <nb-icon icon="arrow-ios-forward-outline"></nb-icon>
                </div>
                <span class="searchItemName">
                  {{ term }}
                </span>
              </div>
              <img
                (click)="navigateTo($event, typeResult, 'misc', true)"
                class="external-link"
                [src]="externalLinkIcon"
              />
            </div>
            <div
              *ngIf="key !== 'ROUTE'"
              id="switcherContext"
              class="cursor-pointer d-flex align-items-center blueprintOnlyBG"
            >
              <div id="config" class="d-flex px-2 py-3">
                <ng-container>
                  <div id="currentBlueprint" class="searchItem">
                    <nb-icon icon="layers-outline" class="configIcon"></nb-icon>
                    <span class="searchItemName">
                      {{
                        key === 'STACK'
                          ? typeResult?.name
                          : typeResult?.data?.stackName
                      }}
                    </span>
                  </div>
                </ng-container>
                <ng-container *ngIf="key === 'CLUSTER' || key === 'RESOURCE'">
                  <div
                    class="separator d-flex align-items-center justify-content-center"
                  >
                    <nb-icon icon="arrow-ios-forward-outline"></nb-icon>
                  </div>
                  <div
                    [id]="
                      typeResult?.data?.dependent
                        ? 'currentDependentEnvironment'
                        : 'currentEnvironment'
                    "
                    class="searchItem"
                  >
                    <nb-icon
                      [icon]="
                        typeResult?.data?.dependent
                          ? 'two-clouds-outline'
                          : 'cloud-download-outline'
                      "
                      class="configIcon"
                      pack="fci"
                    ></nb-icon>

                    <!-- <nb-icon
                      icon="cloud-download-outline"
                      class="configIcon"
                    ></nb-icon> -->
                    <span class="searchItemName">
                      {{
                        key === 'CLUSTER'
                          ? typeResult?.name
                          : typeResult?.data?.clusterName
                      }}
                    </span>
                  </div>
                </ng-container>
                <ng-container *ngIf="key === 'RESOURCE'">
                  <div
                    class="separator d-flex align-items-center justify-content-center"
                  >
                    <nb-icon icon="arrow-ios-forward-outline"></nb-icon>
                  </div>
                  <div id="currentResourceType" class="searchItem">
                    <nb-icon icon="layout-outline" class="configIcon"></nb-icon>
                    <span class="searchItemName">
                      {{ typeResult?.data?.resourceType }}
                    </span>
                  </div>
                </ng-container>

                <ng-container *ngIf="key === 'RESOURCE'">
                  <div
                    class="separator d-flex align-items-center justify-content-center"
                  >
                    <nb-icon icon="arrow-ios-forward-outline"></nb-icon>
                  </div>
                  <div id="currentResource" class="searchItem">
                    <span class="searchItemName">
                      {{ typeResult?.name }}
                    </span>
                  </div>
                </ng-container>
              </div>
            </div>
            <div *ngIf="key !== 'ROUTE'" class="d-flex align-items-center">
              <div
                class="separator d-flex align-items-center justify-content-center"
              >
                <nb-icon icon="arrow-ios-forward-outline"></nb-icon>
              </div>
              <div class="pageName searchItem">
                <span class="searchItemName">
                  {{ typeResult?.data?.urlType }}
                </span>
              </div>
              <img
                (click)="
                  navigateTo(
                    $event,
                    typeResult,
                    typeResult?.data?.urlType,
                    true
                  )
                "
                class="external-link"
                [src]="externalLinkIcon"
              />
            </div>
          </div>
        </div>
        <app-message
          *ngIf="!filteredResults?.[key]?.length"
          [imgUrl]="noResults"
          primaryMsg="No Results Found for {{
            tabValues[key]?.title | lowercase
          }}"
          secondaryMsg=""
          [showBtn]="false"
          status="info"
          [changeBackground]="false"
        ></app-message>
      </nb-tab>
    </nb-tabset>
  </nb-card-body>
</nb-card>
